import { createContext } from 'react'

export type InternalApiErrorContextValue = {
  error: any
  addError: (error: any) => void
}

export const InternalApiErrorContext = createContext<InternalApiErrorContextValue>(null!)
